import type { GameState, Viewport } from "../sim/types";
import { SHIP_Y, VP_X } from "../sim/geometry";
import { MAX_CHARGES } from "../sim/constants";
import { C } from "./palette";

/** La nave esta fija al centro y solo rota sobre su propio eje. */
export function drawShip(
  cx: CanvasRenderingContext2D,
  s: GameState,
  now: number,
  vp: Viewport,
): void {
  const x = VP_X(vp);
  const y = SHIP_Y(vp);

  cx.save();
  cx.translate(x, y);
  cx.rotate(s.shipA);
  cx.strokeStyle = s.freeze > 0 ? C.cyan : C.ink;
  cx.lineWidth = 1.7;
  cx.shadowColor = cx.strokeStyle;
  cx.shadowBlur = 11;
  cx.beginPath();
  cx.moveTo(0, -17);
  cx.lineTo(12, 10);
  cx.lineTo(4, 6);
  cx.lineTo(0, 13);
  cx.lineTo(-4, 6);
  cx.lineTo(-12, 10);
  cx.closePath();
  cx.stroke();
  cx.fillStyle = "rgba(6,18,14,0.7)";
  cx.fill();
  cx.shadowBlur = 0;

  const f = 0.5 + 0.5 * Math.sin(now * 0.03);
  cx.strokeStyle = `rgba(255,176,32,${(0.5 + f * 0.5).toFixed(2)})`;
  cx.lineWidth = 1.5;
  cx.beginPath();
  cx.moveTo(0, 13);
  cx.lineTo(0, 19 + f * 8);
  cx.stroke();
  cx.restore();

  // cargas de congelamiento
  for (let i = 0; i < MAX_CHARGES; i++) {
    const px = x - 22 + i * 22;
    const py = y + 32;
    cx.strokeStyle = i < s.charges ? C.cyan : "rgba(30,122,92,0.5)";
    cx.fillStyle = i < s.charges ? "rgba(95,232,255,0.28)" : "transparent";
    cx.lineWidth = 1;
    cx.beginPath();
    cx.moveTo(px, py - 5);
    cx.lineTo(px + 5, py);
    cx.lineTo(px, py + 5);
    cx.lineTo(px - 5, py);
    cx.closePath();
    cx.fill();
    cx.stroke();
  }
}

export function drawShots(cx: CanvasRenderingContext2D, s: GameState): void {
  for (const sh of s.shots) {
    if (!sh.started) continue;
    cx.strokeStyle = C.hot;
    cx.lineWidth = 2.2;
    cx.shadowColor = C.hot;
    cx.shadowBlur = 9;
    cx.beginPath();
    cx.moveTo(sh.x, sh.y);
    cx.lineTo(sh.x - sh.dx * 11, sh.y - sh.dy * 11);
    cx.stroke();
    cx.shadowBlur = 0;
  }
}

export function drawDebris(cx: CanvasRenderingContext2D, s: GameState): void {
  for (const d of s.debris) {
    cx.strokeStyle = C.rock;
    cx.globalAlpha = Math.max(0, d.life) * 0.95;
    cx.lineWidth = 1;
    cx.save();
    cx.translate(d.x, d.y);
    cx.rotate(d.rot);
    cx.beginPath();
    cx.moveTo(-d.len / 2, 0);
    cx.lineTo(d.len / 2, 0);
    cx.stroke();
    cx.restore();
    cx.globalAlpha = 1;
  }
}
